// @flow
export const SET_REPORT_PREVIEW = 'set/report/preview';
export const SET_REPORT_FULL = 'set/report/full';
